import React from 'react';
import { Image, List, Icon } from 'semantic-ui-react';
import avatarPlaceholder from '../assets/avatar_placeholder.jpg';

export const accountText = (source, account) => {
  switch (source) {
    case 'instagram':
      return `@${account}`;
    case 'youtube':
      return `ID: ${account}`;
    default:
      return account;
  }
}

export const accountUrl = (source, uid) => {
  switch (source) {
    case 'instagram':
      return `https://instagram.com/${uid}`;
    case 'youtube':
      return `https://youtube.com/channel/${uid}`;
    default:
      return null;
  }
}

const WinnerItem = ({ user, className }) => {
  const { profile_pic_url: avatar, full_name: fullName, username: account, source = 'instagram' } = user;
  const url = accountUrl(source, account);
  return (
    <List.Item className={className}>
      <Image avatar src={avatar} onError={e => e.target.src = avatarPlaceholder} />
      <List.Content>
        <List.Header>
          {fullName}&nbsp;{url && <a href={url}><Icon size="small" name="share square"/></a>}
        </List.Header>
        <List.Description>
          {accountText(source, account)}
        </List.Description>
      </List.Content>
    </List.Item>
  );
}

export default WinnerItem;